__turbopack_context__.v({
  "reportIssue": "LinkAccountModal-module-scss-module__ZDLWjW__reportIssue",
  "root": "LinkAccountModal-module-scss-module__ZDLWjW__root",
});
